//TODO: Laurel:  name it with the report's name and datestamp it. e.g. reportxyz_20200701.pdf
import { __decorate } from "tslib";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { MineTypeMap } from "../../../../../shared/components/report-form/models/mime-type-map.model";
import { ReportCriteriaConst } from "../../../../../shared/components/report-form/report-criteria-form/report-criteria-constants";
import { ReportService } from "../../../../../shared/components/report-form/report.service";
import { ReportFormBuilder } from "../../../../../shared/components/report-form/report-form-builder";
import { ReportHeadingConstants, ReportHeadingMap } from "../../../../../shared/components/report-form/models/report-heading-model";
import { UserInformationService } from "../../../../../shared/services/user/user-information.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { take } from "rxjs/operators";
let ReportBaseComponent = class ReportBaseComponent {
    userInformationService;
    reportService;
    route;
    formBuilder;
    appControllerService;
    changeDetector;
    mineTypeMap = MineTypeMap;
    criteriaTitle = ReportCriteriaConst.CRITERIA_TITLE;
    creneratReportBtn = ReportCriteriaConst.SUBMIT_BTN_LBL;
    pageName;
    selectedModule;
    selectedOrganisation;
    selectedModuleName;
    selectedOrganisationId;
    selectedOrganisationName;
    reportForm;
    showing;
    constructor(userInformationService, reportService, route, formBuilder, appControllerService, changeDetector) {
        this.userInformationService = userInformationService;
        this.reportService = reportService;
        this.route = route;
        this.formBuilder = formBuilder;
        this.appControllerService = appControllerService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.listenForUrl();
        const report = new ReportFormBuilder(this.formBuilder);
        this.reportForm = report.initReportForm();
    }
    buildRequest() {
        let uploadReport = false;
        let canDownloadInPortal = false;
        if (this.reportForm.value.reportParameters.uploadReport !== undefined && this.reportForm.value.reportParameters.uploadReport !== null) {
            uploadReport = this.reportForm.value.reportParameters.uploadReport;
        }
        else if (this.reportForm.value.reportType.uploadReport !== undefined && this.reportForm.value.reportType.uploadReport !== null) {
            uploadReport = this.reportForm.value.reportType.uploadReport;
        }
        if (this.reportForm.value.reportParameters.canDownloadInPortal !== undefined && this.reportForm.value.reportParameters.canDownloadInPortal !== null) {
            canDownloadInPortal = this.reportForm.value.reportParameters.canDownloadInPortal;
        }
        else if (this.reportForm.value.reportType.canDownloadInPortal !== undefined && this.reportForm.value.reportType.canDownloadInPortal !== null) {
            canDownloadInPortal = this.reportForm.value.reportType.canDownloadInPortal;
        }
        let jobId = 0;
        if (this.reportForm.value.reportType.jobId !== undefined && this.reportForm.value.reportType.jobId !== null) {
            jobId = this.reportForm.value.reportType.jobId;
        }
        const reportRequest = {
            reportID: +this.reportForm.value.reportType.reportID,
            moduleId: +this.appControllerService.selectedModuleID,
            exportType: this.reportForm.value.reportParameters.exportType,
            uploadReport,
            canDownloadInPortal,
            componentType: "Report",
            jobId: +jobId,
            reportDataInfo: this.reportForm.value.reportParameters.reportDataInfo,
            reportCriteria: this.reportForm.value.reportParameters.reportCriteria
        };
        return reportRequest;
    }
    onSubmit() {
        this.validate();
        const model = this.buildRequest();
        this.reportService.generateReport(model).pipe(take(1)).subscribe({
            next: (response) => {
                this.handleReportDownload(response, model);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("Generic Reports", error, CRUDOperation.Get);
            }
        });
    }
    handleReportDownload(response, model) {
        const t = this.mineTypeMap.get(model.exportType).toLocaleLowerCase();
        const file = new Blob([response], {
            type: t,
        });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }
    listenForUrl() {
        this.pageName = ReportHeadingConstants.Report;
        this.pageName = ReportHeadingMap.get(this.pageName);
        this.pageName = this.pageName.toLowerCase();
        this.pageName =
            this.pageName[0].toUpperCase() + this.pageName.substr(1).toLowerCase();
        this.changeDetector.markForCheck();
    }
    validate() {
        this.reportForm.markAllAsTouched();
        this.reportService.submitFormTriger(true);
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: ReportService },
        { type: ActivatedRoute },
        { type: FormBuilder },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ReportBaseComponent = __decorate([
    Component({
        standalone: false,
        template: "",
        changeDetection: ChangeDetectionStrategy.OnPush,
    })
], ReportBaseComponent);
export { ReportBaseComponent };
